<template>
  <div :class="`banner-campaign-${$store.state.campaign}`">
    <template v-if="$store.state.campaign === 'cyber-monday-2023' && promotion.extend">
      <nuxt-link to="/cyber-monday-2023/" class="btn-lg">
        <img src="../../assets/images/campaigns/ds-cme-bg-blog-banner.webp" alt="72% OFF on All Data Science and AI Courses">
      </nuxt-link>
    </template>
    <template v-else-if="$store.state.campaign === 'cyber-monday-2023'">
      <nuxt-link to="/cyber-monday-2023/" class="btn-lg">
        <img src="../../assets/images/campaigns/ds-cm-bg-blog-banner.webp" alt="72% OFF on All Data Science and AI Courses">
      </nuxt-link>
    </template>
    <template v-else-if="$store.state.campaign === 'black-friday-2023'">
      <nuxt-link to="/black-friday-2023/" class="btn-lg">
        <img src="../../assets/images/campaigns/ds-bf-bg-blog-banner.webp" alt="72% OFF on All Data Science and AI Courses">
      </nuxt-link>
    </template>
    <template v-else-if="$store.state.campaign === 'free-weeks-2023'">
      <nuxt-link to="/free-weeks-2023/" class="btn-lg">
        <img src="../../assets/images/campaigns/ds-fw-blog-banner.webp" alt="All Data and AI Courses FREE For 14 DAYS">
      </nuxt-link>
    </template>
    <template v-else-if="$store.state.campaign === 'get-future-ready'">
      <p class="main">
        GET FUTURE-READY
      </p>
      <p class="small">
        WITH
      </p>
      <p class="highlight-special" title="DATA AND">
        DATA AND
      </p>
      <p class="highlight-special" title="AI SKILLS">
        AI SKILLS
      </p>
      <p class="text-1">
        at <span class="bold">65% Off</span>
      </p>
      <nuxt-link to="/get-future-ready/" class="btn-lg">
        Buy Annual Plan
      </nuxt-link>
    </template>
    <template v-else-if="$store.state.campaign === 'future-proof'">
      <div class="code-block">
        <img :src="require('@itbpbg/lms-components/src/assets/images/campaign-future-proof/learn-future-proof.webp')">
      </div>
      <p class="main">
        Data and AI Skills
      </p>
      <p class="text-1">
        at 65% Off
      </p>
      <nuxt-link to="/future-proof-career/" class="btn-lg">
        Buy Annual Plan
      </nuxt-link>
    </template>
    <template v-else-if="$store.state.campaign === 'campaign-chat-gpt'">
      <p class="take">
        TAKE
      </p>
      <div class="box">
        <div class="svg">
          <TechnologyAI />
        </div>
        <div class="title">
          Intro to ChatGPT and Generative AI course
        </div>
      </div>
      <p class="for-free">
        FOR FREE
      </p>
      <p class="desc">
        until <strong>July 27</strong>
      </p>
      <nuxt-link to="/courses/intro-to-chatgpt-and-generative-ai/" class="btn-lg">
        Take Course
      </nuxt-link>
    </template>
    <template v-else-if="$config.campaign === 'free'">
      <div class="courses">
        ALL COURSES
      </div>
      <div class="free">
        FREE
      </div>
      <div class="days">
        <span>for</span>21<span>days</span>
      </div>
      <nuxt-link to="/signup/" class="btn-primary btn-lg">
        Start Now
      </nuxt-link>
    </template>
    <template v-else-if="$config.campaign === 'black-friday'">
      <div class="campaign">
        BLACK FRIDAY
      </div>
      <BlackFridayFonts :class-name="'blog'" :words="['72%']" />
      <p class="off">
        OFF
      </p>
      <nuxt-link :to="'/black-friday-2022/'" class="btn-primary btn-lg">
        GET NOW
      </nuxt-link>
    </template>
    <template v-else-if="$config.campaign === 'cyber-monday'">
      <img class="background-img" src="../../assets/images/campaigns/cm-banners/cyber-monday-blog-banner.png">
      <div class="cm-campaign">
        CYBER MONDAY
      </div>
      <div class="font-wrapper">
        <div class="cm-font-wrapper cm-fonts">
          <div campaign="72%" class="top-side">
            72%
          </div>
          <div campaign="72%" class="bottom-side">
            72%
          </div>
        </div>
        <p class="cm-off">
          OFF
        </p>
      </div>
      <nuxt-link :to="'/cyber-monday-2022/'" class="btn-primary btn-lg btn-cm">
        GET NOW
      </nuxt-link>
      <img class="bg-visual-1" src="../../assets/images/campaigns/cm-banners/cm-blog-banner-visuals-1.png">
      <img class="bg-visual-2" src="../../assets/images/campaigns/cm-banners/cm-blog-banner-visuals-2.png">
      <img class="bg-visual-3" src="../../assets/images/campaigns/cm-banners/cm-blog-banner-visuals-3.png">
      <img class="bg-visual-4" src="../../assets/images/campaigns/cm-banners/cm-blog-banner-visuals-4.png">
    </template>
    <template v-else-if="$config.campaign === 'jumpstart'">
      <div class="main">
        {{ jumpstartBanner.title }}
      </div>
      <div class="with">
        {{ jumpstartBanner.subtitle }}
      </div>
      <div class="special">
        {{ jumpstartBanner.subtitle2 }}
      </div>
      <div class="discounts">
        {{ jumpstartBanner.subtitle3 }}
      </div>
      <nuxt-link :to="'/jumpstart-2023/'" class="btn-primary btn-lg">
        {{ jumpstartBanner.btn }}
      </nuxt-link>
    </template>
    <template v-else-if="$config.campaign === 'got-what-it-takes'">
      <p class="campaign-title">
        <span class="highlighted-left">GOT WHAT</span>
        <span class="highlighted-right">IT TAKES?</span>
      </p>
      <p class="promo-subtitle">
        Master Data Science at <span class="highlighted">65% off</span>
      </p>
      <nuxt-link :to="'/got-what-it-takes/'" class="btn-primary btn-got-what-it-takes">
        Save Now
      </nuxt-link>
    </template>
    <template v-else-if="$store.state.campaign === 'one-of-two-hundred'">
      <div class="title">
        <span class="first-line">GRAB <span class="highlighted">1 OF 200</span></span>
        <span class="second-line">SPECIAL-PRICE</span>
        <span class="third-line">ANNUAL PLANS</span>
      </div>
      <nuxt-link :to="'/one-of-two-hundred/'" class="btn-primary btn-one-of-two-hundred">
        Grab {{ oneof200Banner.discount }}% OFF
      </nuxt-link>
    </template>
  </div>
</template>

<script>
import TechnologyAI from '@itbpbg/lms-components/src/assets/svg/tech-responsive-artificial-intelligence.svg?vue-component';
import BlackFridayFonts from '@itbpbg/lms-components/src/components/BlackFridayFonts';

export default {
  components: {
    TechnologyAI, BlackFridayFonts,
  },
  props: { promotion: { type: Object, default: () => ({}), required: false } },
};
</script>

<style lang="scss" scoped>
.banner-campaign-black-friday-2023,
.banner-campaign-cyber-monday-2023 {
  max-width: 100%;

  a {
    display: block;
  }

  img {
    border-radius: 10px;
    display: block;
    width: 100%;
  }
}

.banner-campaign-chat-gpt {
  width: 100%;
  background-image: url('@itbpbg/lms-components/src/assets/images/campaign-chat-gpt/campaign-chat-gpt-bg-blog.webp');
  background-size: cover;
  color: var(--main-light);
  text-align: center;
  padding: 58px 28px;
  border-radius: 10px;
  max-width: 410px;

  .take {
    font-size: 32px;
    font-weight: 500;
    margin: 0 0 4px;
  }

  .box {
    display: flex;
    align-items: center;
    background-color: var(--main-dark-light-1);
    border: 2px solid #56BFC7;
    border-radius: 6px;

    .svg {
      padding: 17px 12px 17px 10px;
      background-color: var(--main-dark);
      border-top-left-radius: 6px;
      border-bottom-left-radius: 6px;
      flex: 0 0 auto;

      svg {
        height: 45px;

        [fill] {
          fill: #16A180;
        }

        [stroke] {
          stroke: #16A180;
        }
      }
    }

    .title {
      font-size: 18px;
    }
  }

  .for-free {
    font-size: 48px;
    font-weight: 700;
    margin: 14px 0 0;
    color: var(--main-yellow);
  }

  .desc {
    font-size: 22px;
    margin: 0;
  }

  .btn-lg {
    background-color: var(--main-yellow);
    color: var(--main-dark);
    display: block;
    width: 100%;
    height: 52px;
    border: none;
    border-radius: 4px;
    line-height: 12px;
    font-size: 18px;
    font-weight: 600;
    margin-top: 20px;
  }
}

.banner-campaign-future-proof {
  background-image: url('../../assets/images/campaigns/future-proof/fpc-proof-bg-blog.webp');
  background-size: cover;
  background-position: center;
  text-align: center;
  padding: 0 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 330px;
  min-height: 395px;
  border-radius: 10px;
  overflow: hidden;

  .code-block img {
    max-width: 100%;
  }

  .main {
    font-size: 28px;
    color: var(--extreme-blue-2);
    text-shadow: 0 2px 4px rgba(37, 244, 238, 0.5);
    margin: 12px 0;
    font-weight: 900;
    text-transform: uppercase;
  }

  .text-1 {
    font-size: 52px;
    color: var(--extreme-yellow);
    margin: 0;
    font-weight: 700;
  }

  .btn-lg {
    margin-top: var(--spacing-40);
    height: 56px;
    width: 100%;
    border-radius: 5px;
    background-color: var(--extreme-yellow);
    font-size: 18px;
    color: var(--main-dark);
    font-weight: 600;
  }
}

.banner-campaign-get-future-ready {
  position: relative;
  color: var(--main-light);
  text-align: center;
  padding: 0 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 330px;
  min-height: 395px;
  border-radius: 10px;
  overflow: hidden;
  text-transform: uppercase;

  &:after {
    content: '';
    z-index: -2;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url('../../assets/images/campaigns/get-future-ready/dsgfr-bg-blog.webp');
    background-size: cover;
    background-position: center;
  }

  p {
    margin: 0;
  }

  .main {
    font-size: 26.5px;
    color: var(--main-yellow-light-2);
    font-weight: 500;
  }

  .highlight-special {
    line-height: 1.1;
    font-size: 53.8px;
    position: relative;
    display: flex;
    font-weight: 900;
    text-shadow: 0 3.6274824142456055px 8.809599876403809px rgba(37, 244, 238, 0.5);
    color: var(--extreme-blue-2);
    padding-right: 5px;
    margin-right: -5px;

    &:after {
      content: attr(title);
      position: absolute;
      color: transparent;
      -webkit-text-stroke: 0.5px var(--main-light);
      text-shadow: none;
      top: 5px;
      left: 5px;
      z-index: -1;
    }

    + .highlight-special {
      font-size: 59.6px;
    }
  }

  .bold {
    font-size: 37px;
    font-weight: 800;
  }

  .btn-lg {
    margin-top: var(--spacing-40);
    height: 56px;
    width: 100%;
    border-radius: 5px;
    background-color: var(--extreme-yellow);
    font-size: 18px;
    line-height: 18px;
    color: var(--main-dark);
    font-weight: 600;
  }
}

.free {
  padding: var(--spacing-36) var(--spacing-30);
  text-align: center;
  background: var(--main-dark);
  border-radius: 10px;

  .courses {
    font-size: 40px;
    line-height: 42px;
    font-weight: 700;
    padding: 0 20px;
  }

  .free {
    font-size: 105px;
    line-height: 124px;
    color: var(--extreme-blue);
    font-weight: 600;
    position: relative;
    margin-bottom: var(--spacing-4);
    display: inline-block;

    &:after {
      content: "FREE";
      position: absolute;
      top: 4px;
      color: transparent;
      -webkit-text-stroke: 1px var(--extreme-blue);
      left: 8px;
    }
  }

  .days {
    font-size: 54px;
    line-height: 64px;
    font-weight: 800;
    display: flex;
    align-items: center;
    justify-content: center;

    span {
      font-weight: 500;
      font-size: 20px;
      color: var(--main-light-shade-4);
    }

    span:first-of-type {
      margin-right: 4px;
    }

    span:last-of-type {
      margin-left: 4px;
    }
  }

  .btn-primary {
    background: var(--main-yellow);
    border-color: transparent;
    color: var(--main-dark-shade-0);
    font-weight: 600;
    width: 100%;
    margin-top: var(--spacing-24);

    &:hover {
      background: var(--main-yellow-shade-2);
    }
  }
}

.black-friday {
  background-image: url('../../assets/images/campaigns/bf-landing/blog-banner.png');

  .campaign {
    font-weight: 900;
    font-size: 39px;
  }

  .off {
    margin: 0;
    float: right;
    font-weight: 700;
    font-size: 48px;
    letter-spacing: 0.05em;
  }

  .btn-primary {
    border: 0;
    border-radius: 0;
    background: var(--extreme-yellow);
    color: var(--main-dark-shade-0);
    font-weight: 600;
    margin: var(--spacing-16) 0;
  }
}

.cyber-monday {
  position: relative;
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
  flex-wrap: wrap;

  .background-img {
    width: 100%;
  }

  .cm-campaign {
    font-weight: 900;
    font-size: 36px;
    line-height: 42px;
    color: var(--extreme-blue);
    text-shadow: 0 2px 5px rgba(37, 244, 238, 0.5), 1.5px 5px 8px #2D0CEC;
    position: absolute;
    top: 50px;
  }

  .font-wrapper {
    background-image:
      linear-gradient(var(--extreme-yellow), var(--extreme-yellow)),
      linear-gradient(var(--extreme-yellow), var(--extreme-yellow)),
      linear-gradient(var(--extreme-yellow), var(--extreme-yellow)),
      linear-gradient(var(--extreme-yellow), var(--extreme-yellow));
    background-repeat: no-repeat;
    background-size: 27px 3px;
    background-position: top left, top right, bottom left, bottom right;
    border: solid var(--extreme-yellow);
    border-width: 0 3px;
    width: 290px;
    position: absolute;
    top: 110px;
    display: flex;
    flex-direction: column;

    .cm-fonts {
      margin: auto;
      text-align: center;
      filter: drop-shadow(0 0 10px #195FF5);
      width: 260px;
      line-height: 120px;
      height: 120px;

      .top-side,
      .bottom-side {
        font-weight: 800;
        font-size: 130px;
        color: var(--extreme-blue);
        position: relative;
        top: 0;
        left: 0;
        text-shadow: 2px 2px #142251;
      }

      .top-side:after,
      .bottom-side:after {
        content: attr(campaign);
        font-size: 130px;
        font-weight: 800;
        color: var(--extreme-fucsia);
        top: -3px;
        left: 3px;
        position: absolute;
        mix-blend-mode: screen;
        text-shadow: 2px 2px #142251;
      }

      .top-side {
        clip-path: inset(0 0 53% 0);
        left: 3px;
        top: 6px;
      }

      .bottom-side {
        clip-path: inset(45% 0 0 0);
        top: -114px;
      }
    }

    .cm-off {
      font-weight: 700;
      font-size: 47px;
      line-height: 55px;
      letter-spacing: 0.05em;
      color: var(--extreme-yellow);
      margin: 0;
      padding-left: var(--spacing-16);
    }
  }

  .btn-cm {
    border-bottom: 8px solid #020C20;
    border-radius: 0;
    background: var(--extreme-yellow);
    color: var(--main-dark-shade-0);
    font-weight: 600;
    margin: var(--spacing-16) 0;
    width: 290px;
    position: absolute;
    top: 290px;
  }

  .bg-visual-1 {
    position: absolute;
    top: 169px;
    left: 49px;
  }

  .bg-visual-2 {
    position: absolute;
    top: 240px;
    left: 170px;
  }

  .bg-visual-3 {
    position: absolute;
    top: 260px;
    left: 164px;
  }

  .bg-visual-4 {
    position: absolute;
    top: 160px;
    right: 0;
  }
}

.jumpstart {
  background-image: url('../../assets/images/campaigns/jumpstart-2023-landing/jumpstart-blog-banner.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  text-align: center;
  color: var(--main-light);
  border-radius: 10px;
  height: 395px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 345px;

  .main {
    font-weight: 900;
    font-size: 32px;
    line-height: 38px;
    text-shadow: 0 3.47052px 8.42841px rgba(37, 244, 238, 0.5), 0 0 13.8821px rgba(25, 245, 238, 0.5);
  }

  .with {
    font-weight: 400;
    font-size: 24px;
  }

  .special {
    color: var(--extreme-blue);
    font-weight: 900;
    font-size: 49.7778px;
    line-height: 59px;
    text-shadow: 0 2.10464px 5.11128px rgba(37, 244, 238, 0.5), 0 0 8.41857px rgba(25, 245, 238, 0.5);
  }

  .discounts {
    color: var(--extreme-blue);
    font-weight: 900;
    font-size: 36.56px;
    line-height: 43.21px;
    text-shadow: 0 2.10464px 5.11128px rgba(37, 244, 238, 0.5), 0 0 8.41857px rgba(25, 245, 238, 0.5);
  }

  .btn-primary {
    color: var(--main-dark);
    background-color: var(--main-yellow);
    border: none;
    width: 100%;
    max-width: 270px;
    margin-top: 28px;

    &:hover {
      background-color: var(--main-yellow-shade-1);
    }

    &:active {
      background-color: var(--main-yellow-shade-2);
    }
  }
}

.got-what-it-takes {
  background-image: url('../../assets/images/campaigns/got-what-it-takes-landing/gwt-blog-banner-bg.jpg');
  max-width: 345px;
  height: 395px;
  padding: var(--spacing-70) var(--spacing-30);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  text-align: center;
  color: var(--main-light);
  border-radius: 10px;

  .campaign-title {
    position: relative;
    height: 119px;
    padding-left: 0;
    margin: 0;

    .highlighted-left {
      padding-left: var(--spacing-8);
      position: absolute;
      top: 3px;
      left: 50%;
      transform: translateX(-50%);
      height: 54px;
      width: 100%;
      font-weight: 700;
      line-height: 110%;
      font-size: 49px;
      display: block;
      text-shadow:
        0 0 0 #3DAFB8,
        -1px 1px 0 #3DAFB8,
        -2px 2px 0 #3DAFB8,
        -3px 3px 0 #3DAFB8,
        -4px 4px 0 #3DAFB8,
        -5px 5px 0 #3DAFB8,
        -6px 6px 0 #3DAFB8,
        -7px 7px 0 #3DAFB8,
        -8px 8px 0 #3DAFB8,
        -9px 9px 0 #3DAFB8,
        -10px 10px 0 #3DAFB8,
        -11px 11px 0 #3DAFB8;
    }

    .highlighted-right {
      padding-left: var(--spacing-8);
      position: absolute;
      top: 63px;
      left: 50%;
      transform: translateX(-50%);
      height: 61px;
      width: 100%;
      font-size: 56px;
      font-weight: 700;
      line-height: 110%;
      display: block;
      text-shadow:
        0 0 0 #CEA40A,
        -1px 1px 0 #CEA40A,
        -2px 2px 0 #CEA40A,
        -3px 3px 0 #CEA40A,
        -4px 4px 0 #CEA40A,
        -5px 5px 0 #CEA40A,
        -6px 6px 0 #CEA40A,
        -7px 7px 0 #CEA40A,
        -8px 8px 0 #CEA40A,
        -9px 9px 0 #CEA40A,
        -10px 10px 0 #CEA40A,
        -11px 11px 0 #CEA40A;
    }
  }

  .promo-subtitle {
    display: block;
    padding: 0 var(--spacing-16);
    margin-top: var(--spacing-12);
    margin-bottom: var(--spacing-16);
    font-weight: 500;
    font-size: 24px;
    line-height: 110%;

    .highlighted {
      font-weight: 800;
      color: var(--accent);
    }
  }

  .btn-got-what-it-takes {
    width: 270px;
    height: 56px;
    margin: 0 auto;
    background: var(--main-yellow);
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 600;
    letter-spacing: 0.02em;
    color: var(--main-dark);

    &:hover {
      background-color: var(--main-yellow-shade-1);
    }

    &:active {
      background-color: var(--main-yellow-shade-2);
    }
  }
}

.one-of-two-hundred {
  background-image: url('../../assets/images/campaigns/one-of-200-landing/oth-blog-banner-bg.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  max-width: 330px;
  height: 395px;
  border-radius: 10px;
  padding: var(--spacing-90) 34px;
  text-align: center;

  .title {
    margin-bottom: 58px;

    > span {
      display: block;
    }
  }

  .first-line {
    color: var(--main-light);
    font-weight: 700;
    font-size: 34px;
    line-height: 110%;

    .highlighted {
      color: var(--extreme-yellow);
    }
  }

  .second-line {
    font-weight: 700;
    font-size: 26px;
    line-height: 110%;
    color: var(--extreme-fucsia);

    .highlighted {
      font-weight: 700;
      font-size: 26px;
    }
  }

  .third-line {
    color: var(--main-light);
    font-weight: 700;
    font-size: 31px;
  }

  .btn-one-of-two-hundred {
    width: calc(100% - 9px);
    height: 56px;
    font-weight: 600;
    font-size: 18px;
    line-height: 100%;
    letter-spacing: 0.02em;
    cursor: pointer;
    color: var(--main-dark);
    background: var(--extreme-yellow);
    border-radius: 7px;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    transition-duration: 320ms;
    box-shadow:
      0 0 0 #B7B700,
      1px 1px 0 #B7B700,
      2px 2px 0 #B7B700,
      3px 3px 0 #B7B700,
      4px 4px 0 #B7B700,
      5px 5px 0 #B7B700,
      6px 6px 0 #B7B700,
      7px 7px 0 #B7B700,
      8px 8px 0 #B7B700,
      9px 9px 0 #B7B700;

    &:hover {
      color: var(--main-dark);
      background: #E7E700;
      box-shadow:
        0 0 0 #A7A700,
        1px 1px 0 #A7A700,
        2px 2px 0 #A7A700,
        3px 3px 0 #A7A700,
        4px 4px 0 #A7A700,
        5px 5px 0 #A7A700,
        6px 6px 0 #A7A700,
        7px 7px 0 #A7A700,
        8px 8px 0 #A7A700,
        9px 9px 0 #A7A700;
    }

    &:active {
      box-shadow: none;
      transition-duration: 50ms;
      transform: translate(9px, 9px);
    }
  }
}

@include bp($bp-laptop) {
  .banner-campaign-future-proof {
    .main {
      font-size: 26px;
    }

    .text-1 {
      font-size: 48px;
    }
  }

  .banner-campaign-get-future-ready {
    .main {
      font-size: 24.6px;
    }

    .highlight-special {
      font-size: 50.6px;

      + .highlight-special {
        font-size: 56.2px;
      }
    }
  }
}

@include bp($bp-mobile) {
  .banner-campaign-future-proof {
    padding: 0 25px;
  }

  .banner-campaign-get-future-ready {
    .main {
      font-size: 24.6px;
    }

    .highlight-special {
      font-size: 50.6px;

      + .highlight-special {
        font-size: 56.2px;
      }
    }
  }
}

@include bp($bp-phone) {
  .single-post-preview .blog-preview {
    .one-of-two-hundred {
      padding: var(--spacing-90) var(--spacing-28);

      .title {
        margin-bottom: var(--spacing-28);
      }

      .first-line,
      .second-line {
        margin-bottom: var(--spacing-8);
      }

      .btn-one-of-two-hundred {
        width: 262px;
        margin: 0;
      }
    }
  }
}
</style>
